"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatEventsServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/event/events");
class ChatEventsService extends client_1.RWSService {
    constructor() {
        super(...arguments);
        this.eventListeners = new Map();
    }
    /**
     * Subscribe to an event
     */
    subscribe(eventName, callback) {
        if (ChatEventsService.VERBOSE) {
            console.log('[ChatEventsService] Subscribing to event:', eventName);
        }
        if (!this.eventListeners.has(eventName)) {
            this.eventListeners.set(eventName, []);
        }
        this.eventListeners.get(eventName).push(callback);
        if (ChatEventsService.VERBOSE) {
            console.log('[ChatEventsService] Total listeners for', eventName + ':', this.eventListeners.get(eventName).length);
        }
    }
    /**
     * Unsubscribe from an event
     */
    unsubscribe(eventName, callback) {
        if (ChatEventsService.VERBOSE) {
            console.log('[ChatEventsService] Unsubscribing from event:', eventName);
        }
        const listeners = this.eventListeners.get(eventName);
        if (listeners) {
            const index = listeners.indexOf(callback);
            if (index > -1) {
                listeners.splice(index, 1);
                if (ChatEventsService.VERBOSE) {
                    console.log('[ChatEventsService] Removed listener for', eventName + ', remaining:', listeners.length);
                }
            }
            else if (ChatEventsService.VERBOSE) {
                console.log('[ChatEventsService] Callback not found for event:', eventName);
            }
        }
        else if (ChatEventsService.VERBOSE) {
            console.log('[ChatEventsService] No listeners found for event:', eventName);
        }
    }
    /**
     * Emit an event
     */
    emit(eventName, data) {
        if (ChatEventsService.VERBOSE) {
            console.log('[ChatEventsService] Emitting event:', eventName, 'with data:', data);
        }
        const listeners = this.eventListeners.get(eventName);
        if (listeners) {
            if (ChatEventsService.VERBOSE) {
                console.log('[ChatEventsService] Calling', listeners.length, 'listeners for event:', eventName);
            }
            listeners.forEach((callback, index) => {
                try {
                    callback(data);
                    if (ChatEventsService.VERBOSE) {
                        console.log('[ChatEventsService] Successfully called listener', index + 1, 'for event:', eventName);
                    }
                }
                catch (error) {
                    console.error(`[ChatEventsService] Error in listener ${index + 1} for event ${eventName}:`, error);
                }
            });
        }
        else if (ChatEventsService.VERBOSE) {
            console.log('[ChatEventsService] No listeners found for event:', eventName);
        }
    }
    /**
     * Handle web search change event
     */
    handleWebSearchChange(checked) {
        if (ChatEventsService.VERBOSE) {
            console.log('[ChatEventsService] Handling web search change:', checked);
        }
        this.emit(events_1.appEvents.frontChatWebSearch, checked);
    }
    /**
     * Handle deep search change event
     */
    handleDeepSearchChange(checked) {
        if (ChatEventsService.VERBOSE) {
            console.log('[ChatEventsService] Handling deep search change:', checked);
        }
        this.emit(events_1.appEvents.frontChatDeepSearch, checked);
    }
    /**
     * Handle audio recording toggle event
     */
    handleAudioRecording(isRecording) {
        this.emit(events_1.appEvents.frontChatAudioRecord, { isRecording });
    }
    /**
     * Handle model sync event
     */
    handleModelSync(model) {
        this.emit('modelSynced', { model });
    }
    /**
     * Clean up all event listeners
     */
    cleanup() {
        this.eventListeners.clear();
    }
}
exports.ChatEventsServiceInstance = ChatEventsService;
ChatEventsService.VERBOSE = false;
exports.default = ChatEventsService.getSingleton();
